import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { setupI18n } from './i18n/index.js';
import { initTheme } from './theme.js';
import { startUpdateCheck } from './pwa/update.js';
import { captureInstallPrompt } from './onboarding.js';
import './index.css';

setupI18n(navigator.languages);

// Chrome bietet die Installation früh an — vor React, sonst ist das Ereignis weg.
captureInstallPrompt();

// Vor dem ersten Rendern: sonst blitzt kurz das falsche Thema auf.
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Offline-first (E2): einmal geholte Daten bleiben brauchbar, auch ohne Netz.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root fehlt in index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary scope="app">
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);

// Aktualisierungen werden angeboten, nicht erzwungen — siehe pwa/update.ts.
startUpdateCheck();
